<template>
  <div class="w-100 h-100 text-center">
    <h1 class="display-2">
      {{ title }}
    </h1>

    <b-container>
      <b-row>
        <b-col cols="12" sm="3">
          <b-form-group>
            <b-form-select v-model="category" size="lg">
              <option :value="null">All Entries</option>
              <option value="uncategorized">Uncategorized</option>
              <option value="thick">Thick</option>
              <option value="thin">Thin</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="3">
          <b-form-group>
            <b-form-input
              v-model="bloodslideCode"
              trim
              size="lg"
              @keypress.enter="find()"
              placeholder="Bloodslide Code"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <b-table
      striped
      hover
      :items="entries"
      :fields="[
        'id',
        'thick_or_thin',
        'mcr_result_1',
        'mcr_result_2',
        'mcr_result_3',
      ]"
    >
      <template v-slot:cell(id)="data">
        <b-link
          :to="{ name: 'thick-or-thin', params: { index: data.index } }"
          v-if="data.item.thick_or_thin === ''"
          >Edit</b-link
        >
        <b-link
          :to="{ name: 'thick-film-counting', params: { index: data.index } }"
          v-if="data.item.thick_or_thin === 'thick'"
          >Edit</b-link
        >
        <b-link
          :to="{ name: 'thin-film-counting', params: { index: data.index } }"
          v-if="data.item.thick_or_thin === 'thin'"
          >Edit</b-link
        >
      </template>
    </b-table>
  </div>
</template>

<script>
// import { HTTP } from "@/utilities/http-common";
// import HandleErrors from "@/utilities/handle-errors";

// import BaseTemplate from '@/layouts/BaseTemplate.vue'
import { mapState } from "vuex";
import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

export default {
  mixins: [
    // BaseTemplate,
    DashboardBaseTemplate,
  ],
  components: {},
  props: {
    prop: {
      type: String,
      required: false,
      default: "Sample prop",
    },
  },
  data: function() {
    return {
      title: "Subject Microscopy",
      category: null,
      bloodslideCode: "",
    };
  },
  watch: {
    // category: function(newQuestion, oldQuestion) {
    category: function() {
      this.find();
    },
  },
  computed: {
    ...mapState("sample", ["sample"]),
    ...mapState("smicroscopy", ["entries", "entry"]),
  },
  created: function() {},
  mounted: function() {
    this.find();
  },
  methods: {
    get: function() {},
    find: function() {
      if (!this.bloodslideCode) {
        return;
      }
      // HTTP.get('/kenya/subject-microscopy').then((response) => {
      //     console.log(response.data);
      // }).catch((error) => {
      //     HandleErrors.HandleErrors(error);
      // });
    },
    patch: function() {},
    delete: function() {},
    clearAll: function() {
      this.bloodslideCode = "";
      this.category = null;
    },
  },
};
</script>
